import Option from '@/models/Option';
import React, { memo, useState } from 'react';
import './style.scss';

interface Props {
    options: Option[];
    onSelectOption: (selectedOptions: string[], option: Option) => void;
    selectedOptionsKey: string[];
}

const SelectButtonOutline: React.FC<Props> = ({ options, onSelectOption, selectedOptionsKey }: Props) => {
    const [selectedOptions, setSelectedOptions] = useState(selectedOptionsKey || []);

    const handleSelectOption = (option: Option) => {
        const index = selectedOptions.indexOf(option.key);
        const newSelectedOptions = [...selectedOptions];
        if (index === -1) {
            newSelectedOptions.push(option.key);
        } else {
            newSelectedOptions.splice(index, 1);
        }
        setSelectedOptions(newSelectedOptions);

        if (onSelectOption) {
            onSelectOption(newSelectedOptions, option);
        }
    };

    return (
        <div className="select-button-outline-container">
            {options.map((opt) => (
                <span className={selectedOptionsKey.includes(opt.key) ? 'active' : ''} key={opt.key} onClick={() => handleSelectOption(opt)}>
                    {opt.value}
                </span>
            ))}
        </div>
    );
};

export default memo(SelectButtonOutline);
